export default __webpack_public_path__ + "static/media/setting-icon-side-bar-right.9f549570.svg";